import { OrderTextWithCatalogComponent } from './order-text-with-catalog.component';
import { GetOrderListResponse } from './api-services/get-order-list.service';

/**
 * 受注コードテキストボックスManageクラス
 *
 * @export OrderTextWithCatalogModel
 * @class OrderTextWithCatalogModel
 */
export class OrderTextWithCatalogModel {
  public orderList: GetOrderListResponse = [];

  /** テキストボックスインスタンス */
  public orderCodeTextInput: OrderTextWithCatalogComponent;
  /** コードリスト取得完了 */
  public completeUpdateOrderCodeList: boolean = <boolean>false;

  /**
   * 発注コードリストアップデート
   *
   * @param serverData:サーバから取得された<Data>タグ
   */
  public updateOrderList(serverData: GetOrderListResponse) {
    if (serverData == null) {
      this.orderList = [];
      return;
    }
    this.orderList = serverData;

    this.completeUpdateOrderCodeList = true;
    this.orderCodeTextInput.changeOrderCodeHandler();
  }

  get selectedCatalogId() {
    if (!this.orderCodeTextInput.text) return '';
    return this.orderList.find(
      _ => this.orderCodeTextInput.text === _.OrderCode
    )?.CatalogID;
  }
}
